// fetch purchased item
export const FETCH_PURCHASE_REQUEST = 'purchase/FETCH_PURCHASE_REQUEST';
export const FETCH_PURCHASE_SUCCESS = 'purchase/FETCH_PURCHASE_SUCCESS';
export const FETCH_PURCHASE_FAILURE = 'purchase/FETCH_PURCHASE_FAILURE';

export const SET_PURCHASES = 'purchase/SET_PURCHASES';
export const SET_RECENT_MANUAL_PURCHASES =
  'purchase/SET_RECENT_MANUAL_PURCHASES';
export const SET_RECENT_VIDEO_LECTURE_PURCHASES =
  'purchase/SET_RECENT_VIDEO_LECTURE_PURCHASES';

export const FETCH_RECENT_PURCHASES_REQUEST =
  'purchase/FETCH_RECENT_PURCHASES_REQUEST';
export const FETCH_RECENT_PURCHASES_SUCCESS =
  'purchase/FETCH_RECENT_PURCHASES_SUCCESS';
export const FETCH_RECENT_PURCHASES_FAILURE =
  'purchase/FETCH_RECENT_PURCHASES_FAILURE';

export const FETCH_PURCHASED_VIDEOS_AND_PROJECTS_AND_EAPROGRAMS_REQUEST =
  'purchase/FETCH_PURCHASED_VIDEOS_AND_PROJECTS_AND_EAPROGRAMS_REQUEST';
export const FETCH_PURCHASED_VIDEOS_AND_PROJECTS_AND_EAPROGRAMS_SUCCESS =
  'purchase/FETCH_PURCHASED_VIDEOS_AND_PROJECTS_AND_EAPROGRAMS_SUCCESS';
export const FETCH_PURCHASED_VIDEOS_AND_PROJECTS_AND_EAPROGRAMS_FAILURE =
  'purchase/FETCH_PURCHASED_VIDEOS_AND_PROJECTS_AND_EAPROGRAMS_FAILURE';

export const SET_PURCHASED_VIDEOS_AND_PROJECTS_AND_EAPROGRAMS =
  'purchase/SET_PURCHASED_VIDEOS_AND_PROJECTS_AND_EAPROGRAMS';
